module.exports = __webpack_public_path__ + "static/media/book-who-is-nemos.e3f54c08.jpg";